import 'proto-polyfill'
import matchAll from 'string.prototype.matchall'

matchAll.shim()
